<script lang="ts" setup>
import { Swiper } from 'swiper'

import helpers from '~/helpers'

defineProps<{
  categoriesData?: any[],
  tagsData?: any[]
}>()

const router = useRouter()

const sliderRef = ref<HTMLElement | null>(null)
const swiper = ref<Swiper | null>(null)

onMounted(() => {
  swiper.value = new Swiper(sliderRef.value as HTMLElement, { freeMode: true, slidesPerView: 'auto' })
})

async function routeTo (categoryData: any): Promise<void> {
  await router.push(helpers.getCategoryPath(categoryData))
}
</script>

<template>
  <div class="wrapper">
    <div ref="sliderRef" class="swiper-container taxonomy-carousel">
      <div class="swiper-wrapper">
        <div
          v-for="x in categoriesData"
          :key="x.id"
          class="swiper-slide taxonomy-carousel__cat cursor-pointer"
          @click="routeTo(x)"
        >
          {{ x.attributes.name }}
        </div>

        <div
          v-for="x in tagsData"
          :key="x.id"
          class="swiper-slide taxonomy-carousel__tag"
          :style="x.attributes.backgroundColor ? 'background-color: ' + x.attributes.backgroundColor : ''"
        >
          {{ x.attributes.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.wrapper {
  @media screen and (max-width: 1020px) {
    margin-left: -16px;
    width: 100%;
  }
}

.swiper-slide {
  border-radius: 14px;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-right: 8px;
  padding: 4px 8px;
  user-select: none;
  width: auto;

  &:last-child {
    margin-right: 0;
  }
}

.taxonomy-carousel {
  @media screen and (max-width: 1020px) {
    overflow: hidden;
    padding: 0 16px;
    width: 100%;
  }

  &__cat {
    background: variables.$body-background-color;
    color: variables.$main-gray-color;
  }

  &__tag {
    background: variables.$main-green-color;
    color: variables.$body-background-color;
  }
}
</style>
